// src/lib/http/session-limit.ts
//
// `?limit=N` sizes a study session to the plan that sent the student there
// (time-boxed sessions, QA finding 8). The 10-minute picker promises "6 review
// cards" or "12 Foundations cards"; without this its Start link opened the
// whole 20- or 24-card batch, so the number on the button wasn't the number
// served.
//
// Optional and backward compatible: no limit, or a garbage one, means the
// route's own default. A limit only ever SHRINKS a session — it is clamped to
// [1, max], and max is the route's existing cap.

/** The session size asked for, clamped to [1, max]; null = use the default. */
export function parseSessionLimit(raw: string | null | undefined, max: number): number | null {
  if (raw == null || raw.trim() === '') return null
  const n = Number(raw)
  if (!Number.isFinite(n)) return null
  return Math.min(max, Math.max(1, Math.floor(n)))
}

/**
 * The `?limit=N` a page forwards from its own URL to its due API, or '' when
 * it was opened without one. `search` is `window.location.search`. Only
 * cleaned here (a whole number, at least 1) — the route clamps to its own cap,
 * so pages don't import server-side session constants to do it twice.
 */
export function forwardSessionLimit(search: string): string {
  const n = parseSessionLimit(new URLSearchParams(search).get('limit'), Number.MAX_SAFE_INTEGER)
  return n == null ? '' : `?limit=${n}`
}
